/**
 * @generated SignedSource<<23f8d16ba43fea2585eb99379c93ee9a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCurrentUserClientId_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentUserClientId_session";
};
export type useCurrentUserClientId_session$key = {
  readonly " $data"?: useCurrentUserClientId_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentUserClientId_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentUserClientId_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "6069d718eafb06a83d08dfe665c11099";

export default node;
